import React, { Component } from "react";
import Rating from 'react-rating';
import ReactSVG from 'react-svg';
import Responsive from 'react-responsive';
class storiesShowItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      storyData:{},
    };
  }
  componentDidMount(){
    try {
      this.setState({
        storyData: this.props.data,
      })
    } catch (error) {
      this.setState({
        storyData: {},
      })
    }
 
  }



  render() {
    return (
        <div className="stories-show-item">
            <div className="stories-show-item-area">
              <div className="stories-show-item-img">
              <Responsive minWidth={ 767 }>
                <img src={this.state.storyData.realImg}></img>
              </Responsive>
              <Responsive maxWidth={ 767 }>
                <img src={this.state.storyData.realImg_mobile}></img>
              </Responsive>
              </div>
              <div className="stories-show-item-conten">
              <Responsive maxWidth={ 767 }>
                {
                  this.props.boardingGatefeeType ? <div className="paragraphSemiBold0 boarding-gatefee-type">Real stories, unedited</div> : null
                }
              </Responsive>                
                <div className="stories-show-item-rating">
                  <Rating emptySymbol={<ReactSVG path="/images/common/star-red.svg" wrapperClassName="svg-wrapper" style={{ width: '25px', height: '25px', marginRight:'9px'  }}/>}   readonly={true} fullSymbol={<ReactSVG path="/images/common/star-red.svg" wrapperClassName="svg-wrapper selected" style={{ width: '25px', height: '25px', marginRight:'7px' }}/>} initialRating={5} />
                </div>
                <div className="stories-show-item-text paragraph2 navy">{this.state.storyData.textData}</div>
                <div className="stories-show-item-botom-info">
                    {/* <i className="round-icon" style={{backgroundColor:this.state.storyData.roundColor}}></i> */}
                    <img className="round-icon-img" src={this.state.storyData.roundImg}></img>
                    < span className="paragraphSemiBold1 navy">{this.state.storyData.name}</span>
                </div>
              </div>
            </div>
            
        </div>
    );
  }
}

export default storiesShowItem;



// WEBPACK FOOTER //
// ./src/views/AA/plan/storiesShowItem.js